// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: ZfrYJ616sV

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicCircleAddButton.module.css"; // plasmic-import: ZfrYJ616sV/css

import VectorIcon from "./icons/PlasmicIcon__Vector"; // plasmic-import: -gNKA8h-Z4/icon
import Add24FilledIcon from "./icons/PlasmicIcon__Add24Filled"; // plasmic-import: W5RSWrKI-W/icon

createPlasmicElementProxy;

export type PlasmicCircleAddButton__VariantMembers = {
  state: "selected" | "unselected" | "small";
};
export type PlasmicCircleAddButton__VariantsArgs = {
  state?: SingleChoiceArg<"selected" | "unselected" | "small">;
};
type VariantPropType = keyof PlasmicCircleAddButton__VariantsArgs;
export const PlasmicCircleAddButton__VariantProps = new Array<VariantPropType>(
  "state"
);

export type PlasmicCircleAddButton__ArgsType = {};
type ArgPropType = keyof PlasmicCircleAddButton__ArgsType;
export const PlasmicCircleAddButton__ArgProps = new Array<ArgPropType>();

export type PlasmicCircleAddButton__OverridesType = {
  root?: p.Flex<"div">;
};

export interface DefaultCircleAddButtonProps {
  state?: SingleChoiceArg<"selected" | "unselected" | "small">;
  className?: string;
}

const $$ = {};

function PlasmicCircleAddButton__RenderFunc(props: {
  variants: PlasmicCircleAddButton__VariantsArgs;
  args: PlasmicCircleAddButton__ArgsType;
  overrides: PlasmicCircleAddButton__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "state",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.state
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootstate_selected]: hasVariant($state, "state", "selected"),
          [sty.rootstate_small]: hasVariant($state, "state", "small"),
          [sty.rootstate_unselected]: hasVariant($state, "state", "unselected")
        }
      )}
    >
      {(
        hasVariant($state, "state", "small")
          ? false
          : hasVariant($state, "state", "unselected")
          ? false
          : true
      ) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__lbL9Q, {
            [sty.freeBoxstate_selected__lbL9QbalMi]: hasVariant(
              $state,
              "state",
              "selected"
            ),
            [sty.freeBoxstate_small__lbL9QWuZx]: hasVariant(
              $state,
              "state",
              "small"
            ),
            [sty.freeBoxstate_unselected__lbL9QVgwL]: hasVariant(
              $state,
              "state",
              "unselected"
            )
          })}
        >
          <VectorIcon
            className={classNames(projectcss.all, sty.svg__r1Dnl, {
              [sty.svgstate_small__r1DnlWuZx]: hasVariant(
                $state,
                "state",
                "small"
              ),
              [sty.svgstate_unselected__r1DnlVgwL]: hasVariant(
                $state,
                "state",
                "unselected"
              )
            })}
            role={"img"}
          />

          {false ? (
            <Add24FilledIcon
              className={classNames(projectcss.all, sty.svg__aoy8Z, {
                [sty.svgstate_small__aoy8ZWuZx]: hasVariant(
                  $state,
                  "state",
                  "small"
                )
              })}
              role={"img"}
            />
          ) : null}
        </div>
      ) : null}
      {(
        hasVariant($state, "state", "small")
          ? true
          : hasVariant($state, "state", "unselected")
          ? true
          : false
      ) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox___5VcrX, {
            [sty.freeBoxstate_selected___5VcrXbalMi]: hasVariant(
              $state,
              "state",
              "selected"
            ),
            [sty.freeBoxstate_small___5VcrXWuZx]: hasVariant(
              $state,
              "state",
              "small"
            ),
            [sty.freeBoxstate_unselected___5VcrXVgwL]: hasVariant(
              $state,
              "state",
              "unselected"
            )
          })}
        >
          {(hasVariant($state, "state", "unselected") ? false : true) ? (
            <VectorIcon
              className={classNames(projectcss.all, sty.svg___1SQUn, {
                [sty.svgstate_small___1SQUnWuZx]: hasVariant(
                  $state,
                  "state",
                  "small"
                ),
                [sty.svgstate_unselected___1SQUnVgwL]: hasVariant(
                  $state,
                  "state",
                  "unselected"
                )
              })}
              role={"img"}
            />
          ) : null}
          {(hasVariant($state, "state", "unselected") ? true : false) ? (
            <Add24FilledIcon
              className={classNames(projectcss.all, sty.svg__jqHif, {
                [sty.svgstate_unselected__jqHifVgwL]: hasVariant(
                  $state,
                  "state",
                  "unselected"
                )
              })}
              role={"img"}
            />
          ) : null}
          {(
            hasVariant($state, "state", "small")
              ? false
              : hasVariant($state, "state", "unselected")
              ? true
              : false
          ) ? (
            <div
              className={classNames(projectcss.all, sty.freeBox__h3WYg, {
                [sty.freeBoxstate_selected__h3WYGbalMi]: hasVariant(
                  $state,
                  "state",
                  "selected"
                ),
                [sty.freeBoxstate_small__h3WYgWuZx]: hasVariant(
                  $state,
                  "state",
                  "small"
                ),
                [sty.freeBoxstate_unselected__h3WYgVgwL]: hasVariant(
                  $state,
                  "state",
                  "unselected"
                )
              })}
            >
              {(hasVariant($state, "state", "unselected") ? false : true) ? (
                <VectorIcon
                  className={classNames(projectcss.all, sty.svg___7NJDf, {
                    [sty.svgstate_small___7NJDfWuZx]: hasVariant(
                      $state,
                      "state",
                      "small"
                    ),
                    [sty.svgstate_unselected___7NJDfVgwL]: hasVariant(
                      $state,
                      "state",
                      "unselected"
                    )
                  })}
                  role={"img"}
                />
              ) : null}
              {(hasVariant($state, "state", "unselected") ? true : false) ? (
                <Add24FilledIcon
                  className={classNames(projectcss.all, sty.svg__jGtUc, {
                    [sty.svgstate_unselected__jGtUcVgwL]: hasVariant(
                      $state,
                      "state",
                      "unselected"
                    )
                  })}
                  role={"img"}
                />
              ) : null}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCircleAddButton__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCircleAddButton__VariantsArgs;
    args?: PlasmicCircleAddButton__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicCircleAddButton__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicCircleAddButton__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCircleAddButton__ArgProps,
          internalVariantPropNames: PlasmicCircleAddButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCircleAddButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCircleAddButton";
  } else {
    func.displayName = `PlasmicCircleAddButton.${nodeName}`;
  }
  return func;
}

export const PlasmicCircleAddButton = Object.assign(
  // Top-level PlasmicCircleAddButton renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicCircleAddButton
    internalVariantProps: PlasmicCircleAddButton__VariantProps,
    internalArgProps: PlasmicCircleAddButton__ArgProps
  }
);

export default PlasmicCircleAddButton;
/* prettier-ignore-end */
